// eslint-disable-next-line import/prefer-default-export
export const MESSAGE_LIST_WIDGET_LIMIT = 1000;
